import { lazy, LazyExoticComponent } from 'react'
import { Permissions } from '../utils/rolesAndPermissions'

export const SETTINGS_ROUTE = `/settings`
const nested = (routeName: string): string => `${SETTINGS_ROUTE}/${routeName}`
export const COMPANY_PROFILE_ROUTE = nested('company')
export const MY_PROFILE_ROUTE = nested('my-profile')
export const USERS_ROUTE = nested('users')
export const SUBSCRIPTIONS_ROUTE = nested('subscriptions')
export const ROLES_ROUTE = nested('roles')

export interface NavItem {
  readonly title: string
  readonly route: string
  readonly iconClass: string
  readonly LazyContent: LazyExoticComponent<() => JSX.Element>
  readonly permissionWhitelist?: readonly string[]
  readonly shouldHideIconIfAccessDenied?: boolean
}

export const componentRoutes: readonly NavItem[] = [
  {
    LazyContent: lazy(() => import('../containers/myProfileContainer')),
    route: MY_PROFILE_ROUTE,
    title: 'My Profile',
    iconClass: 'fas fa-user'
  },
  {
    LazyContent: lazy(() => import('../containers/companyProfileContainer')),
    route: COMPANY_PROFILE_ROUTE,
    title: 'Company Profile',
    iconClass: 'fas fa-desktop',
    permissionWhitelist: [
      'canEditCompanyProfile',
      'servicesCanEditCompanyProfile'
    ]
  },
  {
    LazyContent: lazy(() => import('../containers/usersContainer')),
    route: USERS_ROUTE,
    title: 'User Management',
    iconClass: 'fas fa-users',
    permissionWhitelist: [
      Permissions.canEditCompanyUsers,
      Permissions.etbAdminCanEditEtbAdminRoles,
      Permissions.canInviteUsers,
      Permissions.servicesCanEditCompanyUsers,
      Permissions.servicesCanInviteUsers
    ]
  },
  {
    LazyContent: lazy(() => import('../containers/subscriptionsContainer')),
    route: SUBSCRIPTIONS_ROUTE,
    title: 'Payment & Subscriptions',
    iconClass: 'fas fa-dollar-sign',
    permissionWhitelist: [
      Permissions.canEditCompanySubscriptionSettings,
      Permissions.servicesCanEditCompanySubscriptionSettings
    ]
  },
  {
    LazyContent: lazy(() => import('../containers/rolesContainer')),
    route: ROLES_ROUTE,
    title: 'Roles & Permissions',
    iconClass: 'fas fa-id-card',
    permissionWhitelist: [Permissions.etbAdminCanEditEtbAdminRoles],
    shouldHideIconIfAccessDenied: true
  }
]
